import { render, staticRenderFns } from "./IntercomBubble.vue?vue&type=template&id=43b9a474&scoped=true&"
import script from "./IntercomBubble.vue?vue&type=script&lang=js&"
export * from "./IntercomBubble.vue?vue&type=script&lang=js&"
import style0 from "./IntercomBubble.vue?vue&type=style&index=0&id=43b9a474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b9a474",
  null
  
)

export default component.exports